import React from 'react';
import { useNavigation } from '@react-navigation/native';
import type { NativeStackNavigationProp } from '@react-navigation/native-stack';

import type { AppStackParamList } from '../../navigation/AppNavigation.props';
import { useActiveRouteName } from '../../navigation/useActiveRouteName';

export const useDeliveryMenuNavigation = () => {
  const navigation =
    useNavigation<NativeStackNavigationProp<AppStackParamList>>();
  const handleGoHome = React.useCallback(() => {
    navigation.navigate('MainTabs', {
      screen: 'HomeTab',
      params: { screen: 'Home' },
    });
  }, [navigation]);
  const handleViewOrder = React.useCallback(
    (orderId: string) => {
      navigation.replace('Modal', {
        screen: 'OrderStatus',
        params: { orderId },
      });
    },
    [navigation],
  );

  const route = useActiveRouteName();
  const canGoBackFromDeliveryInFlight = route === 'Location';
  const isValidDeliveryInFlight = ['DeliveryMenu', 'Location'].includes(route);

  return {
    handleGoHome,
    handleViewOrder,
    canGoBackFromDeliveryInFlight,
    isValidDeliveryInFlight,
  };
};
